module.exports = __webpack_public_path__ + "static/media/ic_save_white.09abafe1.svg";